import B2BFlowerServiceSection from "@/containers/Flower/B2BFlowerServiceSection";
import FlowerBenefitSection from "@/containers/Flower/FlowerBenefitSection";
import HeroSection from "@/containers/Flower/HeroSection";
import NowRequestSection from "@/containers/Flower/NowRequestSection";
import FlowerBenefitSecondSection from "@/containers/Flower/FlowerBenefitSecondSection";
import { VStack } from "goi_common";
import React from "react";

import B2BServiceDownloadSection from "@/containers/Home/B2BServiceDownloadSection";
import B2BProcessSection from "@/containers/Price/B2BProcessSection";
import Footer from "@/containers/Home/Footer";

export default function Flower() {
  return (
    <VStack width="100%">
      <HeroSection />
      <B2BFlowerServiceSection />
      <NowRequestSection />
      <FlowerBenefitSection />
      <FlowerBenefitSecondSection />

      <B2BProcessSection />
      <B2BServiceDownloadSection />
      <Footer />
    </VStack>
  );
}
